import React, { useEffect, useState } from "react";
import Sidebar from "../Sidebar";
import Header from "../Header";
import { Link } from "react-router-dom";
import { API } from "../../../API";
import axios from "axios";

import { isAutheticated } from "../../auth/authhelper";
import Pagination from "../../pagination";
import swal from "sweetalert";
import { Player } from "video-react";
// import UserPaypal from "../../customer/UserPaypal";
import Footer from "../Footer";
import { Modal } from "react-bootstrap";

export default function St() {
  const { token } = isAutheticated();
  const [play, setPlay] = useState("");
  const [isModalOpen, setModalStatus] = useState(false);
  const [data, setData] = useState([]);
  const [success, setSuccess] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(15);
  const [showData, setShowData] = useState(data);

  useEffect(() => {
    const fetchData = () => {
      axios
        .get(`${API}/api/staff/admin/viewAll`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          console.log(response);
          setData([...response.data.staff]);
        })
        .catch((err) => {
          console.log(err);
        });
    };

    fetchData();
  }, [success, token]);

  useEffect(() => {
    const loadData = () => {
      const indexOfLastPost = currentPage * itemPerPage;
      const indexOfFirstPost = indexOfLastPost - itemPerPage;
      setShowData(data.slice(indexOfFirstPost, indexOfLastPost));
    };

    loadData();
  }, [data, currentPage, itemPerPage]);

  return (
    <div className='main-content'>
      <div className='page-content'>
        <div className='container-fluid'>
          <div className='row'>
            <div className='col-12'>
              <div className='page-title-box d-flex align-items-center justify-content-between'>
                <h4 className='mb-0'>Team</h4>

                <div className='page-title-right'>
                  <ol className='breadcrumb m-0'>
                    <li className='breadcrumb-item'>
                      <Link to='/dashboard'>SoComOTT</Link>
                    </li>
                    <li className='breadcrumb-item'>Team</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-lg-12'>
              <div className='card'>
                <div className='card-body'>
                  <div className='row ml-0 mr-0  mb-10'>
                    <div className='col-sm-12 col-md-6'>
                      <div className='dataTables_length'>
                        <label className='w-100'>
                          Show{" "}
                          <select
                            style={{ width: "60px" }}
                            name=''
                            value={itemPerPage}
                            onChange={(e) => setItemPerPage(e.target.value)}
                            className='select-w custom-select custom-select-sm form-control form-control-sm'>
                            <option value='15'>15</option>
                            <option value='25'>25</option>
                            <option value='50'>50</option>
                            <option value='100'>100</option>
                          </select>{" "}
                          entries
                        </label>
                      </div>
                    </div>
                    <div className='col-sm-12 col-md-6'>
                      <div className='dropdown d-block'>
                        <Link to='/team/add'>
                          <button
                            type='button'
                            className='btn btn-primary add-btn waves-effect waves-light float-right'>
                            <i className='fa fa-plus' aria-hidden='true'></i>{" "}
                            Add New
                          </button>
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className='table-responsive table-shoot'>
                    <table className='table table-centered table-nowrap mb-0'>
                      <thead className='thead-light'>
                        <tr>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Added On</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data.length !== 0 &&
                          showData.map((lession) => {
                            return (
                              <tr key={lession._id}>
                                <td>{lession.name}</td>
                                <td>{lession.email}</td>
                                <td>
                                  {new Date(lession.createdAt).toDateString()}
                                </td>
                                {/* <td>{lession?.subject?.name}</td> */}
                                <td>
                                  {lession.status ? "Active" : "Inactive"}
                                </td>
                                {/* <td>
                                  {!lession.launch_flag && lession.launchDate && lession.live &&
                                    <span className="badge badge-pill badge-primary font-size-12">
                                      Scheduled
                                    </span>
                                  }
                                </td> */}

                                <td>
                                  {/* {lession.status && (
                                    <button
                                      type='button'
                                      onClick={(e) => {
                                        e.preventDefault();

                                        axios
                                          .patch(
                                            `${API}/api/staff/${lession._id}/suspend`,
                                            { status: false },
                                            {
                                              headers: {
                                                Authorization: `Bearer ${token}`,
                                              },
                                            }
                                          )
                                          .then((res) => {
                                            setSuccess(!success);
                                            swal({
                                              title:
                                                "Staff Member suspended Successfully!",

                                              icon: "success",
                                              // buttons: true,
                                              successMode: true,
                                              dangerMode: false,
                                            });
                                            // console.log(res);
                                          })
                                          .catch((err) => {
                                            console.log(err);
                                            setSuccess(!success);
                                          });
                                      }}
                                      className='btn btn-success btn-sm  waves-effect waves-light btn-table'>
                                      Suspend
                                    </button>
                                  )}
                                  {!lession.status && (
                                    <button
                                      type='button'
                                      onClick={(e) => {
                                        e.preventDefault();

                                        axios
                                          .patch(
                                            `${API}/api/staff/${lession._id}/unsuspend`,
                                            { status: true },
                                            {
                                              headers: {
                                                Authorization: `Bearer ${token}`,
                                              },
                                            }
                                          )
                                          .then((res) => {
                                            setSuccess(!success);
                                            swal({
                                              title:
                                                "Staff Member suspended Successfully!",

                                              icon: "success",
                                              // buttons: true,
                                              successMode: true,
                                              dangerMode: false,
                                            });
                                            // console.log(res);
                                          })
                                          .catch((err) => {
                                            console.log(err);
                                            setSuccess(!success);
                                          });
                                      }}
                                      className='btn btn-success btn-sm  waves-effect waves-light btn-table'>
                                      Activate
                                    </button>
                                  )} */}
                                  {/* {!lession.live && (
                                    <button
                                      type="button"
                                      onClick={(e) => {
                                        e.preventDefault();

                                        axios
                                          .patch(
                                            `${API}/api/adlesson/makelive/${lession._id}`,
                                            {},
                                            {
                                              headers: {
                                                Authorization: `Bearer ${token}`,
                                              },
                                            }
                                          )
                                          .then((res) => {
                                            setSuccess(!success);
                                            swal({
                                              title: "Video is live!",

                                              icon: "success",
                                              buttons: true,
                                              successMode: true,
                                              dangerMode: false,
                                            });
                                            // console.log(res);
                                          })
                                          .catch((err) => {
                                            console.log(err);
                                            setSuccess(!success);
                                          });
                                      }}
                                      className="btn btn-success btn-sm  waves-effect waves-light btn-table"
                                    >
                                      Make Live
                                    </button>
                                  )} */}
                                  {/* <Link to={`/staff/view/${lession._id}`}>
                                    <button
                                      type='button'
                                      className='btn btn-success btn-sm  waves-effect waves-light btn-table'>
                                      View
                                    </button>
                                  </Link> */}

                                  {/* <Link to={`/lessions/view/${lession._id}`}>
                                    <button
                                      type="button"
                                      className="btn btn-info btn-sm  waves-effect waves-light btn-table ml-2"
                                    >
                                      View
                                    </button>
                                  </Link> */}
                                  <Link to={`/team/edit/${lession._id}`}>
                                    <button
                                      type='button'
                                      className='btn btn-primary btn-sm  waves-effect waves-light btn-table ml-2'>
                                      Edit
                                    </button>
                                  </Link>

                                  <button
                                    onClick={(e) => {
                                      e.preventDefault();
                                      swal({
                                        title: "Are you sure?",
                                        text: "Once deleted, you will not be able to recover this Team account!",
                                        icon: "warning",
                                        buttons: ["Cancel", "Delete"],
                                        dangerMode: true,
                                      }).then((willDelete) => {
                                        if (willDelete) {
                                          axios
                                            .delete(`${API}/api/staff/admin/delete/${lession._id}`, {
                                              headers: {
                                                Authorization: `Bearer ${token}`,
                                              },
                                            })
                                            .then((res) => {
                                              setSuccess(!success);
                                              swal({
                                                title: "Deleted!",
                                                text: "Team Member deleted successfully.",
                                                icon: "success",
                                                timer: 2000,
                                                buttons: false,
                                              });
                                            })
                                            .catch((err) => {
                                              console.error(err);
                                              swal({
                                                title: "Error!",
                                                text: "Something went wrong. Please try again.",
                                                icon: "error",
                                                timer: 2000,
                                                buttons: false,
                                              });
                                            });
                                        }
                                      });
                                    }}
                                    type="button"
                                    className="btn btn-danger btn-sm waves-effect waves-light btn-table ml-2"
                                  >
                                    Delete
                                  </button>

                                  {/* <Link to={`/lessions/add-studio/${lession._id}`}>
                                    <button
                                      type="button"
                                      className="btn btn-primary btn-sm  waves-effect waves-light btn-table ml-2"
                                    >
                                      Studio
                                    </button>
                                  </Link> */}
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>

                  <div className='row mt-20'>
                    <div className='col-sm-12 col-md-6 mb-20'>
                      <div
                        className='dataTables_info'
                        id='datatable_info'
                        role='status'
                        aria-live='polite'>
                        Showing {currentPage * itemPerPage - itemPerPage + 1} to{" "}
                        {Math.min(currentPage * itemPerPage, data.length)} of{" "}
                        {data.length} entries
                      </div>
                    </div>

                    <div className='col-sm-12 col-md-6'>
                      <div className='dataTables_paginate paging_simple_numbers float-right'>
                        <ul className='pagination'>
                          <li
                            className={
                              currentPage === 1
                                ? "paginate_button page-item previous disabled"
                                : "paginate_button page-item previous"
                            }>
                            <a
                              href='#'
                              aria-controls='datatable'
                              data-dt-idx='0'
                              tabIndex='0'
                              className='page-link'
                              onClick={() =>
                                setCurrentPage((prev) => prev - 1)
                              }>
                              Previous
                            </a>
                          </li>

                          {!(currentPage - 1 < 1) && (
                            <li className='paginate_button page-item'>
                              <a
                                aria-controls='datatable'
                                data-dt-idx='1'
                                tabIndex='0'
                                href='#'
                                className='page-link'
                                onClick={(e) =>
                                  setCurrentPage((prev) => prev - 1)
                                }>
                                {currentPage - 1}
                              </a>
                            </li>
                          )}

                          <li className='paginate_button page-item active'>
                            <a
                              href='#'
                              aria-controls='datatable'
                              data-dt-idx='2'
                              tabIndex='0'
                              className='page-link'>
                              {currentPage}
                            </a>
                          </li>

                          {!(
                            (currentPage + 1) * itemPerPage - itemPerPage >
                            data.length
                          ) && (
                              <li className='paginate_button page-item '>
                                <a
                                  href='#'
                                  aria-controls='datatable'
                                  data-dt-idx='3'
                                  tabIndex='0'
                                  className='page-link'
                                  onClick={() => {
                                    setCurrentPage((prev) => prev + 1);
                                  }}>
                                  {currentPage + 1}
                                </a>
                              </li>
                            )}

                          <li
                            className={
                              !(
                                (currentPage + 1) * itemPerPage - itemPerPage >
                                data.length
                              )
                                ? "paginate_button page-item next"
                                : "paginate_button page-item next disabled"
                            }>
                            <a
                              href='#'
                              tabIndex='0'
                              className='page-link'
                              onClick={() =>
                                setCurrentPage((prev) => prev + 1)
                              }>
                              Next
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
